export const env = {
    endpoint: window.location.protocol + '//' + process.env.REACT_APP_BASE_URL,
    exchange: window.location.protocol + '//' + process.env.REACT_APP_EXCHANGE_URL,
    adServerUrl: window.location.protocol + '//' + process.env.REACT_APP_AD_SERVER_URL + '/ads',
    rounding_revenue: process.env.REACT_APP_ROUNDING_REVENUE === 'true',
    debug: process.env.debug,
    excludedPublisherIds: process.env.REACT_APP_EXCLUDED_PUBLISHER_IDS
        ? process.env.REACT_APP_EXCLUDED_PUBLISHER_IDS.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
        : [],
};
